<template>
  <app-modal
    v-bind="$attrs"
    class="confirm-modal-container"
    content-class="modal-error"
    title="エラー"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <div class="modal-body text-pre-wrap pa-4">
        {{ error.data.errorMessage }}
      </div>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn variant="outlined" color="primary" @click="cancel"
              >閉じる</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { ApiRequestError } from "@/error/errors";
import { defineComponent } from "vue";
import type { PropType } from "vue";

export default defineComponent({
  name: "ApiErrorModal",
  props: {
    /** エラー */
    error: {
      type: ApiRequestError as PropType<ApiRequestError>,
      required: true,
    },
  },
});
</script>
